import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { internalRequest } from '@/utils/internalRequest';

export function usePayment() {
  const { itineraryId } = useParams();

  const baseUrl = useMemo(() => window.location.origin, []);

  const createPayment = async (paymentMethod: string, customerPaymentId: string) => {
    const url = `/proxy/itinerary/${itineraryId}/payment`;
    const redirectUrl = `${baseUrl}/${itineraryId}/betaling-bevestigd`;

    const body = {
      paymentMethod,
      customerPaymentId,
      redirectUrl,
    };

    try {
      const response = await internalRequest<string>({
        url,
        method: 'POST',
        body,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response) {
        window.location.href = response;
      }
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  };

  return {
    createPayment,
  };
}
